/**
 * @generated SignedSource<<c3448979e74cc21871f02741e0df8db3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lon",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "srcSearchVehicleRentalStationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleRentalStation",
        "kind": "LinkedField",
        "name": "vehicleRentalStations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "srcSearchVehicleRentalStationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleRentalStation",
        "kind": "LinkedField",
        "name": "vehicleRentalStations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a0f7cd29bc4b8ee6222597eadfe3a80",
    "id": null,
    "metadata": {},
    "name": "srcSearchVehicleRentalStationsQuery",
    "operationKind": "query",
    "text": "query srcSearchVehicleRentalStationsQuery {\n  vehicleRentalStations {\n    name\n    stationId\n    lon\n    lat\n    id\n  }\n}\n"
  }
};
})();

node.hash = "625b8677f695fadd23c635f82f7172da";

module.exports = node;
